import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { Nickname as c } from "../../../../../components/Nickname/index.js";
import { AvatarSize as d } from "../../../../../components/Avatar/style.js";
import { htmlToPlainText as C } from "../../../../../services/html/index.js";
import { removeNotParsedHtmlSymbols as p } from "../../../../../services/strings/index.js";
import { DealListCardComment as T, DealCardCommentAvatar as f, DealCardCommentParagraph as h } from "./style.js";
const x = "comentário em destaque desta promoção", u = ({
  commentId: o,
  authorImage: t,
  authorNickname: m,
  content: a,
  contentLabel: n = x,
  onClick: i,
  isVerified: l
}) => {
  const s = C(p(a));
  return /* @__PURE__ */ e(T, { onClick: () => i(o), children: [
    /* @__PURE__ */ r(f, { src: t, size: d.MEDIUM }),
    /* @__PURE__ */ e(h, { "aria-label": n, children: [
      /* @__PURE__ */ r("strong", { children: /* @__PURE__ */ r(c, { isVerified: l, children: m }) }),
      s
    ] })
  ] });
};
export {
  u as HeaderFeaturedComment
};
